<template>
  <div
    :style="{
      '--v-app-chip-full-color': colorVar
    }"
    class="app-chip-full"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "AppChipFull"
};
</script>
<script setup>
import { computed } from "vue";
const props = defineProps({
  color: {
    type: String,
    default: "edit"
  }
});

const colorVar = computed(() => {
  let color = props.color;
  if (color.includes("-darken") || color.includes("-lighten")) {
    return `var(--v-${color})`;
  }
  if (color.startsWith("#")) {
    return color;
  }
  return `var(--v-${color}-base)`;
});
</script>
<style scoped>
.app-chip-full {
  border-radius: 2.8px;
  background: var(--v-app-chip-full-color);
  padding: 2px 12px;
  font-size: 12px;
}
</style>
